import { createContext, useContext, useState, useCallback, useMemo } from "react";
import translations from "./translations";

const LanguageContext = createContext(null);

const LANG_KEY = "futura_lang";

const getInitialLang = () => {
  try {
    return localStorage.getItem(LANG_KEY) || "es";
  } catch (error) {
    return "es";
  }
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(getInitialLang);

  const setLang = useCallback((newLang) => {
    setLangState(newLang);
    try {
      localStorage.setItem(LANG_KEY, newLang);
    } catch (error) {
    }
  }, []);

  const t = useCallback((key, params) => {
    let text = translations[lang]?.[key] || translations.es[key] || key;
    if (params) {
      Object.entries(params).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) throw new Error("useLanguage must be used within LanguageProvider");
  return context;
};
